import React from 'react';
import { useState } from 'react';
import { Grid, Popover, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import CustomToolbar from '../../helpers/CustomToolbar';
import useStore from '../../store/useStore';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import ColumnVisibleSessions from '../../helpers/ColumnVisibleSessions';


const ListViewSessions = () => {
  // Set Local state
  const [popoverState, setPopoverState] = useState({
    anchor: null,
    content: null,
  });

  // Get global State slices
  const { gridData, gridOptions, loading } = useStore((state: any) => ({
    gridData: state.MUIdataSessions,
    gridOptions: state.gridOptions,
    loading: state.loading,
  }));

  // Popover functions
  const handlePopoverOpen = (event: any) => {
    const field = event.currentTarget.dataset.field;
    const id = event.currentTarget.parentElement.dataset.id;
    const row: any = gridData.rows.find((r: any) => String(r.id) === id);
    if (field !== 'picture' && row[field] !== undefined && row[field] !== '') {
      setPopoverState({ content: row[field], anchor: event.currentTarget });
    }
  };

  const handlePopoverClose = () => {
    setPopoverState({ anchor: null, content: null });
  };

  const open = Boolean(popoverState.anchor);

  // Get pagination information from state
  const { currentSessionPage, sessionsPerPage, changeCurrentSessionPage } = useStore((state: any) => ({
    currentSessionPage: state.currentSessionPage,
    sessionsPerPage: state.sessionsPerPage,
    changeCurrentSessionPage: state.changeCurrentSessionPage,
  }));

  //calculate pagination slice interval
  const indexOfLastPost = currentSessionPage * sessionsPerPage;
  const indexOfFirstPost = indexOfLastPost - sessionsPerPage;

  //slice cards to get paginated posts
  const paginatedRows = gridData.rows.slice(indexOfFirstPost, indexOfLastPost);

  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    changeCurrentSessionPage(value)
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  const columnVisibilityModel =
  {
    /*
     { field: 'MonitorTitle', headerName: 'Session title', width: 400 },
{ field: 'TimeSessionStartEnd', headerName: 'Time', width: 150 },
{ field: 'DateSession', headerName: 'Date', width: 120 },
{ field: 'RoomName', headerName: 'Room', width: 120 },
{ field: 'Building', headerName: 'Building', width: 120 },
{ field: 'MeetingType', headerName: 'Type', width: 120 },
{ field: 'Message', headerName: 'Invitation to', width: 150 },
{ field: 'Notes', headerName: 'Notes', width: 150 },
    id: false,
    brokerId: false,
    status: false,*/
    Message: false,
    Notes: false
  };

  return (
    <>
      <div className="ituContainer">
        {/* <Grid container style={{ width: '100%', margin: '3rem auto 0' }} height={sessionsPerPage * 73}> */}
        <Grid container style={{ width: '100%', height: '1100px', margin: '3rem auto 0' }}>
          <Grid item xs={12}>
            <DataGrid
              columns={gridData.columns} //../helpers/ColumnsSessions.tsx
              columnVisibilityModel={ColumnVisibleSessions()}
              rows={paginatedRows}
              //rowHeight={gridOptions.rowHeight}
              //autoHeight={true}
              pageSize={sessionsPerPage}
              hideFooterPagination={true}
              hideFooter={true}
              components={{
              }}
              loading={loading}
              componentsProps={{
                cell: {
                  onMouseEnter: handlePopoverOpen,
                  onMouseLeave: handlePopoverClose,
                },
              }}
              sx={{
                "& .MuiDataGrid-columnHeaderTitle": {
                  whiteSpace: "normal",
                  lineHeight: "normal"
                },
                "& .MuiDataGrid-columnHeader": {
                  // Forced to use important since overriding inline styles
                  height: "unset !important"
                },
                "& .MuiDataGrid-columnHeaders": {
                  // Forced to use important since overriding inline styles
                  maxHeight: "168px !important"
                }
              }}
            />
          </Grid>
        </Grid>

        {gridData.rows.length > sessionsPerPage ? (

          <Grid item xs={12}>
            <Stack spacing={2}>
              <Pagination count={Math.ceil(gridData.rows.length / sessionsPerPage)} page={currentSessionPage} onChange={handlePageChange} style={{
                justifyContent: "center",
                display: 'flex',
                marginTop: "1rem"
              }} />
            </Stack>
          </Grid>
        ) : null
        }
      </div>
    </>
  );
};

export default ListViewSessions;
